const Card = ({ extra, children, ...rest }) => {
  return (
    <div
      className={`relative flex flex-col rounded-[20px] bg-clip-border text-primary shadow-none ${
        extra ?? ""
      }`}
      {...rest}
    >
      {children}
    </div>
  );
};
export default Card;
